<template>
    <v-container fluid>
        <v-layout row>
            <v-dialog v-model="uxDialogData" persistent max-width="400px">

                <v-card>
                    <v-card-title>
                        <span class="headline">Zugangscode</span>
                    </v-card-title>
                    <v-card-text>

                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex md3>
                                    <v-text-field v-model="inCode" label="Code"></v-text-field>
                                </v-flex>


                            </v-layout>
                        </v-container>

                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click="loadData()">Anwenden</v-btn>
                    </v-card-actions>
                </v-card>

            </v-dialog><!-- Input for Data Generation -->

            <v-flex xs12 sm offset-sm0>

                <h4>{{uxTitle}}</h4>
                <v-data-table :headers="headers"
                              :items="dataTable"
                              :loading="loading"
                              :pagination.sync="pagination"
                              class="elevation-1">

                    <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>

                    <template slot="items" slot-scope="props">
                        <td class="text-xs-left">{{ props.item.counter }}</td>
                        <td class="text-xs-left">{{ props.item.time }}</td>
                        <td class="text-xs-left">{{ props.item.key }}</td>
                        <td class="text-xs-left">{{ props.item.value }}</td>
                    </template>
                </v-data-table>
            </v-flex>

        </v-layout>
    </v-container>
</template>

<script>
    import firebase from "firebase/compat/app";
    import 'firebase/compat/firestore';


    export default {
        data() {
            return {
                uxDialogData: true,
                uxTitle: "Liste noch nicht geladen. Code eingeben.",

                loading: false,
                isListenerRunning: false,

                inCode:"",

                // Tabelle mit den Daten
                dataTable: [],

                pagination: {
                    sortBy: 'counter',
                    descending: true,
                    rowsPerPage: -1
                },

                headers: [
                    {
                        text: '#',
                        align: 'left',
                        sortable: true,
                        value: 'counter',
                    },

                    {
                        text: 'Zeitstempel',
                        align: 'left',
                        sortable: false,
                        value: 'time',
                    },

                    {
                        text: 'Key',
                        align: 'left',
                        value: 'key',
                    },
                    {
                        text: 'Value',
                        align: 'left',
                        sortable: false,
                        value: 'value',
                    },

                ]
            };
        },

        computed: {

        },

        methods: {
            loadData() {

                // Close the dialog
                this.uxDialogData = false;

                if (this.inCode != "2013") {
                    this.$store.commit('setSnackbarText', 'Falscher Code');
                      return;
                }

               

                this.uxTitle = "Serveraufrufe";

                // Read the data
                let dataRef;
                dataRef = firebase.firestore().collection("itFormcalls").orderBy("timestamp", "asc");

                let tableLine;
                let counter;

                if (!this.isListenerRunning) {
                    this.isListenerRunning = true;
                    dataRef.onSnapshot(querySnapshot => {

                        this.loading = true;

                        // Reset the dataTable
                        this.dataTable = [];
                        counter = 0;

                        querySnapshot.forEach(doc => {
                            counter++;
                            // Iterate through keys

                            if (doc.data().params.length == 0) {
                                tableLine = {
                                    counter: counter,
                                    time: doc.data().timestamp.toDate() + " ",
                                    key: "<no values>",
                                    value: " "
                                };

                                this.dataTable.push(tableLine);
                            }
                            else {
                                doc.data().params.forEach(entry => {

                                    tableLine = {
                                        counter: counter,
                                        time: doc.data().timestamp.toDate() + " ",
                                        key: entry.key,
                                        value: entry.value
                                    };

                                    this.dataTable.push(tableLine);

                                });
                            }

                        });

                        this.loading = false;
                    });
                }
            }
        },


    };
</script>

<style scoped>
</style>
